import React      from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import AuthService from "../../../api/AuthService";
// import LoaderHelper from "../../../utils/Loader/LoaderHelper";
import { useLocation, useNavigate } from "react-router-dom";
import ViewRecruitmentPage from "../../../../entities/DashboardPage/HRModule/ViewRecruitment"
import LoaderHelper from "../../../../utils/Loader/LoaderHelper";
import AuthService from "../../../../api/AuthService";

const ViewRecruitment = () => {
  const { state } = useLocation();
  const { item } = state || {};
  const permissionObj = localStorage.getItem("permission");
  const permission = JSON.parse(permissionObj);
  const role = localStorage.getItem("role");
  console.log(item,"params")
  const navigate = useNavigate();
  const handleCloseRecruitment = async(id) =>{
    LoaderHelper.loaderStatus(true);
    try {
      const result = await AuthService.handleCloseRecruitment(id);
      if (result?.success) {
        LoaderHelper.loaderStatus(false);
        navigate("/dashboard/recruitment")
        // console.log(result, "result getemployee")
      } else {
        LoaderHelper.loaderStatus(false);
        // console.log(result?.message, "kjshakjh");
      }
    } catch (error) {
      LoaderHelper.loaderStatus(false);
      // console.error("Error occurred:", error);
    }
  }
  return (
    <>
      <ViewRecruitmentPage permission={permission} role={role} item={item} handleCloseRecruitment={handleCloseRecruitment}/>
    </>
  )

}

export default ViewRecruitment;
